import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex items-center w-full space-x-2" }
const _hoisted_2 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-exclamation-circle-fill",
  viewBox: "0 0 16 16"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "w-full" }

import { PropType, computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AlertCard',
  props: {
  type: {
    type: String as PropType<"success" | "warning" | "danger" | "info">,
    required: true,
  },
  hideIcon: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;



const typeClasses = computed(() => {
  let c = "";

  switch (props.type) {
    case "success":
      c = "text-black bg-alert-success border-alert-success-600";
      break;
    case "warning":
      c = "text-black bg-alert-warning border-alert-warning-400";
      break;
    case "danger":
      c = "text-black bg-alert-warning border-alert-warning-600";
      break;
    case "info":
      c = "text-black bg-alert-primary border-alert-primary-600";
      break;
  }

  return c;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_unref(typeClasses), 'flex items-center justify-between p-4 border rounded-md'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!__props.hideIcon)
        ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_4))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ])
  ], 2))
}
}

})